import { atom } from 'jotai';

import { UserInterfaceSettingProps } from 'src/types/user-interface-setting';

export const userInterfaceSettingAtom = atom<UserInterfaceSettingProps | null>(null);
